import axios from "axios";
import { apiUrl } from "./inFormTypes";
import Cookies from "universal-cookie";

const cookies = new Cookies();

const securityHeaders = {
    "X-Frame-Options": "Deny",
    "X-Content-Type-Options": "nosniff",
    "X-XSS-Protection": "1; mode=block",
    "Referrer-Policy": "same-origin",
    "Strict-Transport-Security": "max-age=31536000; includeSubDomains; preload",
};

export const api = axios.create({
    baseURL: apiUrl,
});

api.interceptors.request.use((config) => {
    config.headers = config.headers || {};
    const token = cookies.get("token");
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    Object.assign(config.headers, securityHeaders);
    return config;
});

const handleAuthError = () => {
    cookies.remove("role");
    cookies.remove("token");
    window.location.href = "/SignIn";
};

api.interceptors.response.use(
    (response) => response,
    (error) => {
        const status = error?.response?.status;
        if ((status === 401 || status === 403) && cookies.get("token")) {
            handleAuthError();
        }
        return Promise.reject(error);
    }
);

export const apiFetch = async (url, method = "get", params, type) => {
    try {
        const config = {
            headers: { "Content-Type": type ? type : "application/json" },
        };
        let response;
        if (method === "post") {
            response = await api.post(url, params, config);
        } else if (method === "put") {
            response = await api.put(url, params, config);
        } else if (method === "delete") {
            response = await api.delete(url, config);
        } else {
            response = await api.get(url);
        }
        return {
            ok: true,
            data: response.data,
            status: response.status,
            error: "",
        };
    } catch (err) {
        const status = err?.response?.status;
        const data = err?.response?.data;
        return {
            ok: false,
            data,
            status,
            error:
                (typeof data === "string" ? data : data?.message) ||
                err?.message ||
                "BadRequest",
        };
    }
};

export const axiosReq = async (url, kind, params, type) => {
    const config = {
        headers: { "Content-Type": type ? type : "application/json" },
    };
    try {
        let response;
        if (kind === "post") {
            response = await api.post(url, params, config);
        } else if (kind === "get") {
            response = await api.get(url);
        } else if (kind === "delete") {
            response = await api.delete(url, config);
        } else if (kind === "put") {
            response = await api.put(url, params, config);
        } else {
            return "BadRequest";
        }

        if (kind === "get") {
            if (response.status === 200 || response.status === 201) {
                return response.data;
            }
        } else {
            if (
                response.status === 200 ||
                response.status === 201 ||
                response.status === 204
            ) {
                return response;
            }
        }

        if (response.status === 401 || response.status === 403) {
            handleAuthError();
            return;
        }

        if (kind === "put") {
            return response;
        }
        return "BadRequest";
    } catch (err) {
        const status = err?.response?.status;
        if (status === 401 || status === 403) {
            return;
        }
        if (kind === "post") {
            return err?.response;
        }
        if (kind === "delete" || kind === "put") {
            return err?.response?.data;
        }
        return "BadRequest";
    }
};
